import { useState } from 'react';
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuthMethods } from '@trader-dashboard/shared';
import { GoogleLogo } from '@/components';
// import { useParams } from 'react-router-dom';

export const SettingsPage = (): React.ReactNode => {
  const { loaded, emailPasswordLinked, googleLinked, linkEmailPassword, linkGoogle, sendResetPasswordEmail } = useAuthMethods();
  //const { accountId } = useParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleEmailPasswordLink = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      await linkEmailPassword(email, password);
      setEmail('');
      setPassword('');
      setConfirmPassword('');
    } catch (error) {
      setError((error as Error).message);
    }
  };

  const handleGoogleLink = async () => {
    setError('');
    setSuccess('');
    try {
      await linkGoogle();
    } catch (error) {
      setError((error as Error).message);
    }
  };

  const handleResetPassword = async () => {
    setError('');
    setSuccess('');
    try {
      await sendResetPasswordEmail();
      setSuccess('Password reset email sent.');
    } catch (error) {
      setError((error as Error).message);
    }
  };

  if (!loaded) {
    return <div>Loading...</div>;
  }

  return (
    <div className="flex flex-col gap-8">
      <Card>
        <CardHeader>
          <CardTitle className="text-2xl">Connected Accounts</CardTitle>
          <CardDescription>
            Manage your connected authentication methods
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          {error && (
            <div className="text-red-500 mb-4">{error}</div>
          )}
          {success && (
            <div className="text-green-600 mb-4">{success}</div>
          )}
          
          {/* Email/Password Section */}
          <div className="space-y-4">
            <h3 className="text-lg font-medium">Email & Password</h3>
            {emailPasswordLinked ? (
              <div className="space-y-3">
                <div className="flex items-center space-x-2">
                  <span className="text-green-600">✓</span>
                  <span>Email connected</span>
                </div>
                <Button type="button" variant="outline" onClick={handleResetPassword}>
                  Reset password
                </Button>
              </div>
            ) : (
              <form onSubmit={handleEmailPasswordLink} className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="email">Email</Label>
                  <Input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="password">Password</Label>
                  <Input
                    id="password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="confirmPassword">Confirm Password</Label>
                  <Input
                    id="confirmPassword"
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                  />
                </div>
                <Button type="submit">Connect Email & Password</Button>
              </form>
            )}
          </div>

          {/* Google Section */}
          <div className="space-y-4">
            <h3 className="text-lg font-medium">Google Account</h3>
            {googleLinked ? (
              <div className="flex items-center space-x-2">
                <span className="text-green-600">✓</span>
                <span>Google Account Connected</span>
              </div>
            ) : (
              <Button onClick={handleGoogleLink} variant="outline" className="w-full sm:w-auto">
                <GoogleLogo className="mr-2 h-4 w-4" />
                Connect Google Account
              </Button>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}; 
